<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'BlogCategoryGetVo' : 'BlogCategoryAddVo'"
            :data="tmpBlogCategory" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateBlogCategory"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateBlogCategoryLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{blogCategory.name}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== blogCategory.name"
          @click="onDeleteBlogCategory"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteBlogCategoryLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'BlogCategory',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpBlogCategory: {},
      updateBlogCategoryLoading: false,
      deleteBlogCategoryLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      blogCategory: state => state.blog.blogCategory,
    }),
  },
  methods: {
    ...mapActions({
      getBlogCategory: 'blog/getBlogCategory',
      updateBlogCategory: 'blog/updateBlogCategory',
      addBlogCategory: 'blog/addBlogCategory',
      deleteBlogCategory: 'blog/deleteBlogCategory',
    }),
    ...mapMutations({
      setBlogCategory: 'blog/setBlogCategory',
    }),
    goBack() {
      this.$router.push({path: '/blog-category'})
    },
    onFormChange (data) {
      this.tmpBlogCategory = {...data}
    },
    onAddOrUpdateBlogCategory () {
      if (this.tmpBlogCategory.id) {
        this.updateBlogCategoryLoading = true
        this.updateBlogCategory(this.tmpBlogCategory)
          .then(() => {
            this.updateBlogCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateBlogCategoryLoading = false
          })
      } else {
        this.updateBlogCategoryLoading = true
        this.addBlogCategory(this.tmpBlogCategory)
          .then(() => {
            this.updateBlogCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateBlogCategoryLoading = false
          })
      }
    },
    onDeleteBlogCategory () {
      this.deleteBlogCategoryLoading = true
      this.deleteBlogCategory(this.blogCategory.id)
          .then(() => {
            this.deleteBlogCategoryLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteBlogCategoryLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getBlogCategory(this.$route.params.id).then(() => {
        this.tmpBlogCategory = this.blogCategory
      })
    }
  },
  destroyed() {
    this.setBlogCategory({})
  }
}
</script>
